// Components
import taskListDataDecorator from '../taskList/taskListDataDecorator';
import Task from './Task';

export default taskListDataDecorator(Task);
